import { Star } from "lucide-react";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
    {
      name: "Mathew Rodriguez",
      role: "CEO, FinStream",
      text: "Intelisine didn't just build our app; they helped us refine our entire business model. The strategic insights were worth more than the development cost itself.",
    },
    {
      name: "Sadhana Srinivas",
      role: "Founder, Lush & Lustre",
      text: "Professional, timely, and incredibly talented. They took our vague idea and turned it into a market-ready product in record time.",
    },
    {
      name: "Chandhni Shanker",
      role: "Founder, CFS",
      text: "The code quality is exceptional. Our internal team was impressed by how scalable and clean the architecture was. A truly premium service.",
    },
    {
      name: "Akshay Ramalingam",
      role: "Director, Astricx Solutions",
      text: "We needed a partner who understood both hardware integrations and modern web tech. Intelisine bridged that gap perfectly.",
    },
  ];

export function Testimonials() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1920
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    // Set initial width
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);
    }
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate slidesToShow based on window width
  const getSlidesToShow = () => {
    if (windowWidth <= 640) return 1;
    if (windowWidth <= 1024) return 2;
    return 3;
  };

  const slidesToShow = getSlidesToShow();

  const settings = {
    dots: true,
    infinite: testimonials.length > slidesToShow,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
  };

  return (
    <section className="py-16 md:py-24 bg-slate-50">
      <style>{`
        .testimonials-slider .slick-list {
          margin: 0 -12px;
        }
        .testimonials-slider .slick-slide {
          padding: 0 12px;
          height: auto;
        }
        .testimonials-slider .slick-track {
          display: flex;
          align-items: stretch;
        }
        .testimonials-slider .slick-slide > div {
          height: 100%;
          display: flex;
        }
        .testimonials-slider .slick-slide > div > div {
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
        }
      `}</style>
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-[#FD5750] font-bold text-sm tracking-widest uppercase mb-2 block">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
            What Our Clients Say
          </h2>
        </div>

        <div className="px-0 md:px-4 testimonials-slider">
          <Slider key={windowWidth} {...settings}>
            {testimonials.map((t, i) => (
              <div key={i}>
                <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-slate-100 h-full flex flex-col">
                  <div className="flex gap-1 mb-4 text-yellow-400">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star
                        key={star}
                        size={16}
                        fill="currentColor"
                      />
                    ))}
                  </div>
                  <p className="text-slate-600 mb-6 italic leading-relaxed flex-grow">
                    "{t.text}"
                  </p>
                  <div className="mt-auto">
                    <h4 className="font-bold text-slate-900">
                      {t.name}
                    </h4>
                    <p className="text-sm text-slate-500">
                      {t.role}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}